/* eslint-disable no-return-assign */
/* eslint-disable camelcase */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-else-return */
import React, { useCallback, useEffect, useRef, useState } from 'react'
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  TextField,
  Divider,
  Tooltip,
  Checkbox,
  makeStyles,
  Paper,
  withStyles,
  ClickAwayListener,
  MenuList,
  Grow,
  Popper,
  MenuItem,
  Box,
  Button,
} from '@material-ui/core'
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline'
import HistoryIcon from '@material-ui/icons/History'
import ImageIcon from '@material-ui/icons/Image'
import AccessTimeIcon from '@material-ui/icons/AccessTime'
import LaunchIcon from '@material-ui/icons/Launch'
import InputMask from 'react-input-mask'
import { useDispatch, useSelector } from 'react-redux'
import classNames from 'classnames'
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core'
import {
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
  arrayMove,
} from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

import RIESelect from '../../../components/RIESelect'
import {
  exportFormatedMoney,
  renderRouteRole,
  truncateNumber,
} from '../../../../util/utils'
import NumberFormatCustom from '../../../components/NumberFormat'
import {
  downloadImagesAsZip,
  edit,
  fetchAttendanceInit,
  fetchCommissionedPersons,
} from '../../AttendanceActions'
import {
  getServiceItemKey,
  isReworkBlocked,
  REWORK_BLOCKED_MESSAGE,
} from '../ServiceItemUpdateHelper'

import TimeModalInfo from './TimeModalInfo'
import colors from '../../../../assets/colors'
import {
  mdiAutorenew,
  mdiDelete,
  mdiDotsVertical,
  mdiDragVertical,
  mdiHistory,
  mdiImage,
  mdiImageMultiple,
  mdiLaunch,
  mdiNoteTextOutline,
} from '@mdi/js'
import Icon from '@mdi/react'
import fontSizes from '../../../../assets/fontSizes'
import SelectField from '../../../components/SelectField'
import { Link } from 'react-router-dom/cjs/react-router-dom'
import NumberFormat from 'react-number-format'
import Decimal from 'decimal.js'
import InputNumberCustom from '../../../../components/hooks/BaseInputNumber'
import ItemRollbackStatus from './ItemRollbackStatus'
import ItemObservations from './ItemObservations'
import ItemImages from './ItemImages'
import ItemConfirmModal from './ItemConfirmModal'
import consts from '../../../../util/consts'

const useStyles = makeStyles({
  // input: {
  //   '& input[type=number]': {
  //     '-moz-appearance': 'textfield',
  //   },
  //   '& input[type=number]::-webkit-outer-spin-button': {
  //     '-webkit-appearance': 'none',
  //     margin: 0,
  //   },
  //   '& input[type=number]::-webkit-inner-spin-button': {
  //     '-webkit-appearance': 'none',
  //     margin: 0,
  //   },
  // },
  paper: {
    marginRight: 0,
    borderRadius: '10px',
    color: colors.textPrimary,
    fontSize: fontSizes.text,
    boxShadow: '0px 0px 7px 0px #00000040',
  },
  ref: {
    width: '24px',
    height: '24px',
    position: 'absolute',
    backgroundColor: '#FFFF',
    transform: 'rotate(45deg)',
    right: '-7px',
    '&:hover': {
      backgroundColor: '#FFFF',
    },
  },
  menuList: {
    padding: '10px',
  },
  menuItem: {
    padding: '0 2px',
    height: 'auto',
    lineHeight: '1',
    transition: 'all .4s ease-in-out',
    '&:hover': {
      backgroundColor: 'inherit',
      color: colors.primary,
    },
  },
  menuItemLi: {
    padding: 0,
    margin: 0,
    display: 'flex',
    justifyContent: 'flex-start',
    width: '100%',
    borderRadius: 0,
    transition: 'all .4s ease-in-out',
    '&:hover': {
      backgroundColor: 'inherit',
      color: colors.primary,
    },
    fontSize: '14px',
  },
  menuItemLiIcon: {
    marginRight: '12px',
  },
})

const StyledTableCellBody = withStyles(theme => ({
  head: {
    backgroundColor: '#FFFF',
    color: colors.textPrimary,
    borderColor: colors.secondary,
  },
  body: {
    fontSize: 14,
    padding: '8px 12px',
    color: colors.textPrimary,
    borderBottom: `1px dashed ${colors.graylight}`,
  },
}))(TableCell)

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: '#FFFF',
    color: colors.primary,
    padding: '12px 0px',
    // border: '2px',
    borderColor: colors.secondary,
  },
  body: {
    fontWeight: 700,
    fontSize: 14,
  },
}))(TableCell)

const DragHandleContext = React.createContext(null)

function SortableRow({ id, children, className }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  }

  return (
    <DragHandleContext.Provider value={{ attributes, listeners }}>
      <TableRow ref={setNodeRef} style={style} className={className}>
        {children}
      </TableRow>
    </DragHandleContext.Provider>
  )
}

function DragHandle() {
  const { attributes, listeners } = React.useContext(DragHandleContext)
  return (
    <StyledTableCellBody
      align="center"
      style={{ width: '40px', maxWidth: '40px' }}
    >
      <Box
        {...attributes}
        {...listeners}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'grab',
          color: '#bdbdbd',
          touchAction: 'none',
        }}
      >
        <Icon path={mdiDragVertical} size={2} />
      </Box>
    </StyledTableCellBody>
  )
}

function TableServices(props) {
  const styles = useStyles()

  const [open, setOpen] = React.useState(false)
  const [info, setInfo] = React.useState('')
  const [removing, setRemoving] = React.useState(null)
  const [hoverId, setHoverId] = React.useState(null)

  const [itemHistoryOpen, setItemHistoryOpen] = React.useState(false)
  const [itemInfoOpen, setItemInfoOpen] = React.useState(false)
  const [item, setItem] = React.useState('')

  const [rollbackStatusOpen, setRollbackStatusOpen] = React.useState(false)
  const [rollbackStatusId, setRollbackStatusId] = React.useState(null)

  const [observationsOpen, setObservationsOpen] = React.useState(false)
  const [observationsIndex, setObservationsIndex] = React.useState(null)

  const [imagesOpen, setImagesOpen] = useState(false)
  const [imagesIndex, setImagesIndex] = useState(null)

  const [confirmRemoveOpen, setConfirmRemoveOpen] = React.useState(false)
  const [removeTarget, setRemoveTarget] = React.useState(null)

  const [confirmDownloadOpen, setConfirmDownloadOpen] = React.useState(false)
  const [downloadTarget, setDownloadTarget] = React.useState(null)

  const role = useSelector(state => state.auth.role)
  const itemStatuses = useSelector(state => state.attendance.itemStatuses)
  const commissionedPersons = useSelector(
    state => state.attendance.commissionedPersons
  )

  const {
    classes,
    items,
    removeChildren,
    updateChildren,
    discountDisabled,
    openEdit,
    formId,
    updateFieldSelect,
    rework,
    setAllToRework = () => {},
    commission,
    allInRework,
    updateOnlyServiceValue = false,
    swapChildren = () => {},
    reorderChildren = () => {},
    updateItemImages = () => {},
  } = props
  const dispatch = useDispatch()

  const anchorRefs = useRef([])

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: { distance: 5 },
    })
  )

  const handleDragEnd = event => {
    const { active, over } = event
    if (!over || active.id === over.id) return

    const oldIndex = (items ?? []).findIndex(
      i => getServiceItemKey(i) === String(active.id)
    )
    const newIndex = (items ?? []).findIndex(
      i => getServiceItemKey(i) === String(over.id)
    )
    if (oldIndex === -1 || newIndex === -1) return

    reorderChildren(arrayMove([...(items ?? [])], oldIndex, newIndex))
  }

  const handleToggle = id => {
    if (open?.id === id) {
      return setOpen({
        id: '',
      })
    }

    setOpen({
      ...open,
      id,
    })
  }

  const handleClosePopUp = (event, index) => {
    if (
      anchorRefs.current[index] &&
      anchorRefs.current[index].contains(event.target)
    ) {
      return
    }

    setOpen({
      id: '',
    })
  }

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault()
      setOpen({
        id: '',
      })
    }
  }

  const confirmRemove = id => {
    setRemoveTarget(id)
    setConfirmRemoveOpen(true)
  }

  const handleCloseConfirmRemove = useCallback(() => {
    setConfirmRemoveOpen(false)
    setRemoveTarget(null)
  }, [])

  const handleConfirmRemove = () => {
    const id = removeTarget

    setRemoving(id)
    setTimeout(() => {
      removeChildren(id)
      setRemoving(null)
    }, 400)
  }

  const handleOpenInfo = () => {
    setInfo()
    setItemInfoOpen(false)
  }

  const handleClose = useCallback(e => {
    setOpen(false)
  }, [])

  const openTimeInfoModal = id => {
    setInfo(id)
    setItemInfoOpen(true)
  }

  const handleItemHistoryOpen = () => {
    setItemHistoryOpen(true)
  }

  const handleItemHistoryClose = useCallback(() => {
    setItemHistoryOpen(false)
  }, [])

  const handleOpenRollbackStatus = id => {
    setRollbackStatusOpen(true)
    setRollbackStatusId(id)
  }

  const handleCloseRollbackStatus = id => {
    setRollbackStatusOpen(false)
    setRollbackStatusId(null)
  }

  const handleOpenObservations = index => {
    setObservationsIndex(index)
    setObservationsOpen(true)
  }

  const handleCloseObservations = useCallback(() => {
    setObservationsOpen(false)
    setObservationsIndex(null)
  }, [])

  const handleSaveObservations = value => {
    if (observationsIndex === null) return
    updateChildren(observationsIndex, value, 'observations')
  }

  const handleOpenImages = index => {
    setImagesIndex(index)
    setImagesOpen(true)
  }

  const handleCloseImages = useCallback(() => {
    setImagesOpen(false)
    setImagesIndex(null)
  }, [])

  const handleSaveImages = images => {
    if (imagesIndex === null) return
    updateItemImages(imagesIndex, images)
  }

  const openHistoryItem = id => {
    setItem(id)
    handleItemHistoryOpen()
  }

  const confirmDownloadImages = id => {
    setDownloadTarget(id)
    setConfirmDownloadOpen(true)
  }

  const handleCloseConfirmDownload = useCallback(() => {
    setConfirmDownloadOpen(false)
    setDownloadTarget(null)
  }, [])

  const handleConfirmDownloadImages = () => {
    dispatch(downloadImagesAsZip(downloadTarget))
  }

  const renderTooltip = index => {
    // console.log(items[index])

    const { options } = items[index]
    if (options.type === 1) {
      return `Base: ${options.base} - Altura: ${options.altura}`
    } else if (options.type === 2) {
      return `Diâmetro: ${options.diametro}`
    }

    return ''
  }

  const updateCommissionedPerson = (index, person) => {
    updateChildren(index, person, 'commissioned_person')
  }

  const functionToDispatchOnSucess = () => {
    window.location.reload()
  }

  const handleVerifyInProgress = item => {
    const status = item?.status
    const times = item?.times

    if (!status) return false
    if (!times) return false

    if (status?.id != 30) return false

    if (times?.started_at && times?.ended_at) return false

    return true
  }

  useEffect(() => {
    dispatch(fetchCommissionedPersons())
  }, [])

  return (
    <>
      <TimeModalInfo
        handleClose={handleOpenInfo}
        open={itemInfoOpen}
        items={items}
        info={info}
        setHoverId={setHoverId}
        updateChildren={updateChildren}
      />

      <ItemConfirmModal
        open={confirmRemoveOpen}
        description="Deseja remover o serviço da lista?"
        confirmationText="Sim"
        handleOpen={handleCloseConfirmRemove}
        onConfirm={handleConfirmRemove}
      />

      <ItemConfirmModal
        open={confirmDownloadOpen}
        description="Deseja baixar as imagens do serviço?"
        confirmationText="Sim"
        handleOpen={handleCloseConfirmDownload}
        onConfirm={handleConfirmDownloadImages}
      />

      <ItemRollbackStatus
        id={rollbackStatusId}
        open={rollbackStatusOpen}
        handleOpen={handleCloseRollbackStatus}
        functionToDispatchOnSucess={functionToDispatchOnSucess}
      />

      <ItemObservations
        open={observationsOpen}
        item={(items ?? [])[observationsIndex]}
        handleClose={handleCloseObservations}
        onSave={handleSaveObservations}
        disabled={updateOnlyServiceValue}
      />

      <ItemImages
        open={imagesOpen}
        item={(items ?? [])[imagesIndex]}
        handleClose={handleCloseImages}
        onSave={handleSaveImages}
        disabled={updateOnlyServiceValue}
      />

      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
      >
        <TableContainer>
          <Table style={{ overflow: 'hidden' }}>
            <TableHead>
              <TableRow>
                <StyledTableCell align="start" />
                <StyledTableCell align="start">Descrição</StyledTableCell>
                <StyledTableCell align="center">Qtde</StyledTableCell>
                <StyledTableCell align="center">Tipo</StyledTableCell>
                <StyledTableCell align="center">Total H</StyledTableCell>
                <StyledTableCell align="center">Valor</StyledTableCell>
                <StyledTableCell align="center">Desc.%</StyledTableCell>
                <StyledTableCell align="center">Desc. R$</StyledTableCell>
                <StyledTableCell align="center">Total</StyledTableCell>
                <StyledTableCell align="center">Status</StyledTableCell>
                {commission && (
                  <StyledTableCell align="center" style={{ minWidth: '130px' }}>
                    Comissão
                  </StyledTableCell>
                )}
                {rework && (
                  <StyledTableCell align="center" style={{ minWidth: '120px' }}>
                    <Checkbox
                      checked={allInRework}
                      key={`checkbox-rework-${allInRework}`}
                      onChange={e => setAllToRework(e.target.checked)}
                    />
                    Retrabalho
                  </StyledTableCell>
                )}
                <StyledTableCell align="center">Ações</StyledTableCell>
              </TableRow>
            </TableHead>
            <SortableContext
              items={(items ?? []).map(i => getServiceItemKey(i))}
              strategy={verticalListSortingStrategy}
            >
              <TableBody>
                {(items ?? []).map((item, key) => {
                  const sortableId = getServiceItemKey(item)
                  return (
                    <SortableRow
                      key={sortableId}
                      id={sortableId}
                      className={classNames({
                        [classes.attendanceRowLeft]: key % 2 === 0,
                        [classes.attendanceRowRight]: key % 2 === 1,
                        [classes.removeAttendanceLine]: removing === sortableId,
                        [classes.hoverRestoration]:
                          hoverId && hoverId === item?.bar_code,
                      })}
                    >
                      <DragHandle />
                      <StyledTableCellBody
                        align="start"
                        style={{ maxWidth: '200px' }}
                      >
                        {item?.name}
                      </StyledTableCellBody>
                      <StyledTableCellBody align="center">
                        {item?.measureType?.id === 1 && (
                          <Tooltip
                            title={
                              [1].includes(
                                item?.serviceType?.attendance_type_id ||
                                  item?.attendanceType?.id
                              )
                                ? 'Esta quantidade não pode ser alterada'
                                : ''
                            }
                            aria-label="tooltip"
                            style={{ textAlign: 'center', maxWidth: '60px' }}
                          >
                            <TextField
                              disabled={
                                [1, '1'].includes(
                                  item?.serviceType?.attendance_type_id ||
                                    item?.attendanceType?.id
                                ) || updateOnlyServiceValue
                              }
                              value={item.quantity}
                              style={{ textAlign: 'center', maxWidth: '60px' }}
                              InputProps={{
                                inputComponent: NumberFormat,
                                inputProps: {
                                  thousandSeparator: ',',
                                  decimalSeparator: '.',
                                  onValueChange: values => {
                                    updateChildren(
                                      key,
                                      values.value,
                                      'quantity'
                                    )
                                  },
                                  style: { textAlign: 'center' },
                                },
                              }}
                            />
                          </Tooltip>
                        )}

                        {[3, 4]?.includes(item?.measureType?.id) && (
                          <TextField
                            disabled={updateOnlyServiceValue}
                            value={item?.quantity}
                            fullWidth
                            style={{ textAlign: 'center', maxWidth: '60px' }}
                            InputProps={{
                              inputComponent: NumberFormat,
                              inputProps: {
                                thousandSeparator: ',',
                                decimalSeparator: '.',
                                onValueChange: values => {
                                  updateChildren(key, values.value, 'quantity')
                                },
                                style: { textAlign: 'center' },
                              },
                            }}
                          />
                        )}

                        {item?.measureType?.id === 2 && (
                          <Tooltip
                            title={renderTooltip(key)}
                            aria-label="tooltip"
                            style={{ textAlign: 'center', maxWidth: '60px' }}
                          >
                            <TextField
                              disabled={updateOnlyServiceValue}
                              onClick={() => openEdit(key)}
                              value={item.quantity}
                              inputProps={{
                                min: '0',
                                style: {
                                  textAlign: 'center',
                                  maxWidth: '60px',
                                  cursor: 'pointer',
                                },
                              }}
                            />
                          </Tooltip>
                        )}
                      </StyledTableCellBody>

                      <StyledTableCellBody align="center">
                        {item?.measureType.name == 'Unidade' && 'Unit'}
                        {item?.measureType.name == 'Metro Linear' && 'M Lin.'}
                        {item?.measureType.name == 'Metro Quadrado' && 'M²'}
                        {item?.measureType.name == 'Quilos' && 'Kg'}
                      </StyledTableCellBody>

                      <StyledTableCellBody align="center">
                        <InputMask
                          style={{ width: '50px' }}
                          mask="99:99"
                          formatChars={{ 9: '[0-9]', '?': '[0-9/.]' }}
                          maskChar=""
                          value={item?.final_time}
                          placeholder="00:30"
                          onChange={event =>
                            updateChildren(
                              key,
                              event.target.value,
                              'final_time'
                            )
                          }
                          inputProps={{
                            style: { textAlign: 'center' },
                            disabled: updateOnlyServiceValue,
                          }}
                        >
                          {inputProps => <TextField {...inputProps} />}
                        </InputMask>
                      </StyledTableCellBody>

                      <StyledTableCellBody align="center">
                        {item?.serviceType?.edit_final_value ||
                        item?.edit_final_value ? (
                          <Tooltip
                            title={
                              parseFloat(item?.default_value) <
                              parseFloat(item?.base_price)
                                ? `Atenção, valor mínimo para o item: ${exportFormatedMoney(
                                    item?.base_price
                                  )}`
                                : ''
                            }
                            aria-label="tooltip"
                            style={{ textAlign: 'center', maxWidth: '116px' }}
                          >
                            <TextField
                              fullWidth
                              value={item.default_value}
                              onChange={e =>
                                updateChildren(key, e.value, 'default_value')
                              }
                              error={
                                parseFloat(item?.default_value) <
                                parseFloat(item?.base_price)
                              }
                              InputProps={{
                                inputComponent: InputNumberCustom,
                                inputProps: {
                                  prefix: 'R$ ',
                                  style: {
                                    textAlign: 'center',
                                    maxWidth: '116px',
                                    color:
                                      parseFloat(item?.default_value) <
                                      parseFloat(item?.base_price)
                                        ? 'red'
                                        : 'inherit',
                                  },
                                },
                              }}
                            />
                          </Tooltip>
                        ) : (
                          exportFormatedMoney(item?.default_value)
                        )}
                      </StyledTableCellBody>

                      <StyledTableCellBody align="center">
                        <Tooltip
                          title={
                            ![null, 0, ''].includes(discountDisabled)
                              ? 'Campo indisponível! Desconto geral aplicado.'
                              : ''
                          }
                        >
                          <TextField
                            value={item.discount}
                            onChange={e => {
                              updateChildren(key, e.value, 'discount')
                            }}
                            disabled={![null, 0, ''].includes(discountDisabled)}
                            placeholder="0%"
                            InputProps={{
                              inputComponent: InputNumberCustom,
                              inputProps: {
                                suffix: ' %',
                                allowNegative: false,
                                style: {
                                  textAlign: 'center',
                                  maxWidth: '75px',
                                },
                              },
                            }}
                          />
                        </Tooltip>
                      </StyledTableCellBody>

                      <StyledTableCellBody align="center">
                        <TextField
                          disabled
                          placeholder="Valor"
                          value={item?.discount_value || 0}
                          InputProps={{
                            inputComponent: InputNumberCustom,
                            inputProps: {
                              prefix: 'R$ ',
                              style: { textAlign: 'center', maxWidth: '100px' },
                            },
                          }}
                        />
                      </StyledTableCellBody>

                      <StyledTableCellBody align="center">
                        <TextField
                          placeholder="Valor"
                          value={item?.final_value}
                          onChange={e => {
                            updateChildren(key, e.value, 'final_value')
                          }}
                          InputProps={{
                            inputComponent: InputNumberCustom,
                            inputProps: {
                              prefix: 'R$ ',
                              allowNegative: false,
                              style: { textAlign: 'center', maxWidth: '100px' },
                            },
                          }}
                        />
                      </StyledTableCellBody>

                      <StyledTableCellBody align="center">
                        {handleVerifyInProgress(item) ? (
                          <>Em execução</>
                        ) : (
                          <>{item?.status?.name || '-'}</>
                        )}
                      </StyledTableCellBody>

                      {commission && (
                        <StyledTableCellBody align="center">
                          <SelectField
                            style={{ color: 'black', marginTop: '0px' }}
                            options={commissionedPersons}
                            setForm={person =>
                              updateCommissionedPerson(key, person)
                            }
                            data={item?.commissioned_person}
                            uniqueState
                            label="Comissionado"
                          />
                        </StyledTableCellBody>
                      )}
                      {rework && (
                        <StyledTableCellBody padding="checkbox" align="center">
                          <Tooltip
                            title={
                              isReworkBlocked(item)
                                ? REWORK_BLOCKED_MESSAGE
                                : ''
                            }
                          >
                            <span>
                              <Checkbox
                                name="is_rework"
                                checked={Boolean(item.is_rework)}
                                disabled={isReworkBlocked(item)}
                                onChange={e =>
                                  updateChildren(
                                    key,
                                    e.target.checked,
                                    'is_rework'
                                  )
                                }
                              />
                            </span>
                          </Tooltip>
                        </StyledTableCellBody>
                      )}

                      <StyledTableCellBody
                        style={{ maxWidth: '150px' }}
                        align="center"
                      >
                        <IconButton
                          ref={el => (anchorRefs.current[sortableId] = el)}
                          key={sortableId}
                          id={sortableId}
                          aria-controls={
                            open?.id
                              ? `menu-list-grow-${sortableId}`
                              : undefined
                          }
                          aria-haspopup="true"
                          onClick={() => handleToggle(sortableId)}
                        >
                          <Icon path={mdiDotsVertical} size={1} />
                        </IconButton>
                      </StyledTableCellBody>

                      <Popper
                        open={open?.id === sortableId}
                        role={undefined}
                        anchorEl={anchorRefs.current[sortableId]}
                        transition
                        disablePortal
                        style={{ zIndex: 99999999 }}
                        placement="left-end"
                      >
                        {({ TransitionProps, placement }) => (
                          <Grow
                            {...TransitionProps}
                            style={{
                              transformOrigin:
                                placement == 'bottom-start'
                                  ? 'left-start'
                                  : 'left-end',
                            }}
                          >
                            <Paper className={styles.paper}>
                              <ClickAwayListener onClickAway={handleClose}>
                                <MenuList
                                  autoFocusItem={open?.id}
                                  id={`menu-list-grow-${sortableId}`}
                                  onKeyDown={handleListKeyDown}
                                  className={styles.menuList}
                                >
                                  <MenuItem
                                    className={styles.ref}
                                    style={
                                      placement === 'bottom-end'
                                        ? { top: '12px' }
                                        : { bottom: '12px' }
                                    }
                                  />
                                  <MenuItem
                                    onClick={handleClose}
                                    className={styles.menuItem}
                                    disabled={updateOnlyServiceValue}
                                  >
                                    <IconButton
                                      onClick={() => confirmRemove(sortableId)}
                                      className={styles.menuItemLi}
                                    >
                                      <Icon
                                        path={mdiDelete}
                                        size={1}
                                        className={styles.menuItemLiIcon}
                                      />
                                      Excluir
                                    </IconButton>
                                  </MenuItem>

                                  <MenuItem
                                    onClick={handleClose}
                                    className={styles.menuItem}
                                  >
                                    <IconButton
                                      onClick={() =>
                                        handleOpenObservations(key)
                                      }
                                      className={styles.menuItemLi}
                                    >
                                      <Icon
                                        path={mdiNoteTextOutline}
                                        size={1}
                                        className={styles.menuItemLiIcon}
                                      />
                                      Observações
                                    </IconButton>
                                  </MenuItem>

                                  <MenuItem
                                    onClick={handleClose}
                                    className={styles.menuItem}
                                  >
                                    <IconButton
                                      onClick={() => handleOpenImages(key)}
                                      className={styles.menuItemLi}
                                    >
                                      <Icon
                                        path={mdiImageMultiple}
                                        size={1}
                                        className={styles.menuItemLiIcon}
                                      />
                                      Fotos
                                    </IconButton>
                                  </MenuItem>

                                  {formId && (
                                    <MenuItem
                                      onClick={handleClose}
                                      className={styles.menuItem}
                                    >
                                      <IconButton
                                        onClick={() =>
                                          openTimeInfoModal(item.id)
                                        }
                                        className={styles.menuItemLi}
                                      >
                                        <Icon
                                          path={mdiLaunch}
                                          size={1}
                                          className={styles.menuItemLiIcon}
                                        />
                                        Inf. Item.
                                      </IconButton>
                                    </MenuItem>
                                  )}

                                  {formId && (
                                    <MenuItem
                                      onClick={handleClose}
                                      className={styles.menuItem}
                                    >
                                      <IconButton
                                        component={Link}
                                        to={`/service-item/history/${item.id}`}
                                        className={styles.menuItemLi}
                                      >
                                        <Icon
                                          path={mdiHistory}
                                          size={1}
                                          className={styles.menuItemLiIcon}
                                        />
                                        Histórico
                                      </IconButton>
                                    </MenuItem>
                                  )}

                                  {formId && (
                                    <MenuItem
                                      onClick={handleClose}
                                      className={styles.menuItem}
                                    >
                                      <IconButton
                                        onClick={() =>
                                          confirmDownloadImages(item.id)
                                        }
                                        className={styles.menuItemLi}
                                      >
                                        <Icon
                                          path={mdiImage}
                                          size={1}
                                          className={styles.menuItemLiIcon}
                                        />
                                        Download Foto
                                      </IconButton>
                                    </MenuItem>
                                  )}

                                  {renderRouteRole(
                                    ['gerente_lavanderia'],
                                    role
                                  ) &&
                                    ![10, 120, 110].includes(item?.status_id) &&
                                    formId && (
                                      <MenuItem
                                        onClick={handleClose}
                                        className={styles.menuItem}
                                      >
                                        <IconButton
                                          className={styles.menuItemLi}
                                          onClick={() =>
                                            handleOpenRollbackStatus(item.id)
                                          }
                                        >
                                          <Icon
                                            path={mdiAutorenew}
                                            size={1}
                                            className={styles.menuItemLiIcon}
                                          />
                                          Retornar status
                                        </IconButton>
                                      </MenuItem>
                                    )}
                                </MenuList>
                              </ClickAwayListener>
                            </Paper>
                          </Grow>
                        )}
                      </Popper>
                    </SortableRow>
                  )
                })}
              </TableBody>
            </SortableContext>
          </Table>
        </TableContainer>
      </DndContext>
      {/* <Divider variant="fullWidth" /> */}
    </>
  )
}

export default TableServices
